type Track = {
  title: string;
  audio: string;
  clip: string;
  pos: [number, number];
  dark?: boolean;
};

export const tracks: Track[] = [
  {
    title: "01. La garderie d'art",
    audio: "01-la-garderie-d-art.mp3",
    clip: "01-hauts-parleurs_02.webm",
    pos: [863, 270],
  },
  {
    title: "02. Ça tourne",
    audio: "02-ca-tourne.mp3",
    clip: "02-ca-tourne8fps_02.webm",
    pos: [863, 321],
  },
  {
    title: "03. Marins Schtroumpfs",
    audio: "03-marins-schtroumpfs.mp3",
    clip: "03-cymbale_02.webm",
    pos: [863, 372],
  },
  {
    title: "04. Market Tango",
    audio: "04-market-tango.mp3",
    clip: "04-plante_02.webm",
    pos: [863, 423],
  },
  {
    title: "05. St-Mérité les chênes (pt.1)",
    audio: "05-st-merite-les-chenes-pt1.mp3",
    clip: "05-helices_02.webm",
    pos: [863, 474],
  },
  {
    title: "06. St-Mérité les chênes (pt.2) (Hommage aux cinq pachydermes)",
    audio: "06-st-merite-les-chenes-pt2.mp3",
    clip: "06-cadre-photo_02.webm",
    pos: [863, 524],
  },
  {
    title: "07. Patadorf",
    audio: "07-patadorf.mp3",
    clip: "07-reparer-la-machine_02.webm",
    pos: [863, 575],
  },
  {
    title: "08. Buddah.com",
    audio: "08-buddah-com.mp3",
    clip: "08-chercher-vinyle_02.webm",
    pos: [863, 626],
  },
  {
    title: "09. Alice & Marius",
    audio: "09-alice-marius.mp3",
    clip: "09-lecture_02.webm",
    pos: [863, 678],
  },
  {
    title: "10. Elephant_sadness",
    audio: "10-elephant-sadness.mp3",
    clip: "10-fleur-a-vent_02.webm",
    pos: [863, 728],
  },
  {
    title: "11. Thérapie de groupe",
    audio: "11-therapie-de-groupe.mp3",
    clip: "11-tourner-sur-tabouret_02.webm",
    pos: [1198, 270],
  },
  {
    title: "12. Le jambon c'est si bon",
    audio: "12-le-jambon-c-est-si-bon.mp3",
    clip: "12-ou-va-le-cable_02.webm",
    pos: [1198, 321],
  },
  {
    title: "13. Attack of the cows",
    audio: "13-attack-of-the-cows.mp3",
    clip: "13-tous-les-boutons_02.webm",
    pos: [1198, 372],
  },
  {
    title: "14. À nos beurgueurs",
    audio: "14-a-nos-beurgueurs.mp3",
    clip: "14-climatisation_02.webm",
    pos: [1198, 423],
  },
  {
    title: "15. Gustavo Del_Totche",
    audio: "15-gustavo-del-totche.mp3",
    clip: "15-lampe_02.webm",
    pos: [1198, 474],
    dark: true,
  },
  {
    title: "16. Coeur liquide",
    audio: "16-coeur-liquide.mp3",
    clip: "16-bricolage_02.webm",
    pos: [1198, 525],
  },
  {
    title: "17. L'abonnement à la piscine",
    audio: "17-l-abonnement-a-la-piscine.mp3",
    clip: "17-trier-les-vis_02.webm",
    pos: [1198, 575],
  },
  {
    title: "18. Fum thon plastickk",
    audio: "18-fum-thon-plastickk.mp3",
    clip: "18-cafetiere_02.webm",
    pos: [1198, 626],
  },
  {
    title: "19. Roméo & Yvette",
    audio: "19-romeo-yvette.mp3",
    clip: "19-machines-musique_02.webm",
    pos: [1198, 678],
  },
  {
    title: "20. Rêverie pour tortellini n°1",
    audio: "20-reverie-pour-tortellini-n1.mp3",
    clip: "20-couche-par-terre_02.webm",
    pos: [1198, 728],
  },
];
